(function ($) {
	$.fn.visible = function (partial) {
		var $t = $(this),
				$w = $(window),
				viewTop = $w.scrollTop(),
				viewBottom = viewTop + $w.height(),
				_top = $t.offset().top,
				_bottom = _top + $t.height(),
				compareTop = partial === true ? _bottom : _top,
				compareBottom = partial === true ? _top : _bottom;

		return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
	};

	var update_animates = function () {
		$('.solutions a').each(function (i, el) {
			var $el = $(el);
			if ($el.visible(true)) {
				$el.addClass('fadeInUp');
			}
		});
	};

	$(document).ready(function () {
		update_animates();

		$('.city-selector a').click(function (e) {
			e.preventDefault();

			var city = $(this).data('city');
			Cookies.set('city', city);

			$('.city-selector-wrap').remove();

			$('.header-cities .city:contains("' + city + '")').trigger('click');
		});

		$('.header-cities .city').click(function () {
			var $this = $(this);
			var address = $this.data('address');

			$('.header-cities .city').removeClass('active');
			$this.addClass('active');

			$('.header-address').text(address);
		});

		if (!$('body.error404').length) {
			var padding = 310;
			if ($(window).width() < 375) {
				padding = 256;
			}

			var slideout = new Slideout({
				panel: document.getElementById('main'),
				menu: document.getElementById('menu'),
				padding: padding,
				tolerance: 70,
				touch: false,
				side: 'left'
			});

			document.querySelector('.js-slideout-toggle').addEventListener('click', function () {
				slideout.toggle();
			});

			var fixed = document.querySelector('.fixed-header');

			slideout.on('translate', function (translated) {
				fixed.style.transform = 'translateX(' + translated + 'px)';
			});

			slideout.on('beforeopen', function () {
				fixed.style.transition = 'transform 300ms ease';
				fixed.style.transform = 'translateX(' + padding + 'px)';
			});

			slideout.on('beforeclose', function () {
				fixed.style.transition = 'transform 300ms ease';
				fixed.style.transform = 'translateX(0px)';
			});

			slideout.on('open', function () {
				fixed.style.transition = '';
			});

			slideout.on('close', function () {
				fixed.style.transition = '';
			});
		}

		$('.sidemenu-btn').click(function (e) {
			e.preventDefault();
			$('body').removeClass('opened-search').toggleClass('opened-burger-menu');
			setTimeout(function () {
				$('.hamburger').toggleClass('is-active');
			}, 1);
		});

		$('.front-slider').slick({
			infinite: false,
			prevArrow: '<div class="slick-prev"><svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.3752 9.29168L4.54208 9.29168L10.9378 2.89597C11.4096 2.42412 11.4096 1.65924 10.9378 1.18739C10.4659 0.715533 9.70076 0.715533 9.2289 1.18739L0.770567 9.64572C0.298714 10.1176 0.298714 10.8828 0.770567 11.3543L9.2289 19.8126C9.46483 20.0486 9.77416 20.1667 10.0835 20.1667C10.3925 20.1667 10.7019 20.0486 10.9378 19.8126C11.4096 19.3408 11.4096 18.5756 10.9378 18.1041L4.54208 11.7083L23.3752 11.7083C24.0422 11.7083 24.5835 11.1673 24.5835 10.5C24.5835 9.83271 24.0425 9.29168 23.3752 9.29168Z" fill="white"/></svg></div>',
			nextArrow: '<div class="slick-next"><svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.62484 11.7083L20.4579 11.7083L14.0622 18.104C13.5904 18.5759 13.5904 19.3408 14.0622 19.8126C14.5341 20.2845 15.2992 20.2845 15.7711 19.8126L24.2294 11.3543C24.7013 10.8824 24.7013 10.1172 24.2294 9.6457L15.7711 1.18736C15.5352 0.951433 15.2258 0.833319 14.9165 0.833319C14.6075 0.833319 14.2981 0.951433 14.0622 1.18736C13.5904 1.65921 13.5904 2.42439 14.0622 2.89594L20.4579 9.29165L1.62484 9.29165C0.957837 9.29165 0.416504 9.83269 0.416504 10.5C0.416504 11.1673 0.957535 11.7083 1.62484 11.7083Z" fill="white"/></svg></div>',
			dots: true,
			customPaging: function (slider, i) {
				return '';
			}
		});

		$('.wpcf7-acceptance input').change(function () {
			var $this = $(this);
			var $label = $this.closest('label');

			if ($this.is(':checked')) {
				$label.addClass('checked');
			} else {
				$label.removeClass('checked');
			}
		});

		var $galleryWrap = $('.post-gallery-wrap');
		$galleryWrap.each(function () {
			var $wrap = $(this);
			var $gallery = $wrap.find('.post-gallery');
			$gallery.slick({
				arrows: false,
				infinite: false,
				customPaging: function() {
					return '';
				},
				responsive: [
					{
						breakpoint: 768,
						settings: {
							dots: true
						}
					}
				]
			});
			var count = $gallery.find('.post-gallery-item').length;
			$gallery.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				$wrap.find('.slick-next, .slick-prev').removeClass('hide');
				if ((nextSlide + 1) == count) {
					$wrap.find('.slick-next').addClass('hide');
				}

				if (!nextSlide) {
					$wrap.find('.slick-prev').addClass('hide');
				}

				$wrap.find('.post-gallery-count span').text(nextSlide + 1);
			});
			$wrap.find('.slick-next').click(function () {
				$gallery.slick('slickNext');
			});
			$wrap.find('.slick-prev').click(function () {
				$gallery.slick('slickPrev');
			});
		});

		$('.post-gallery').each(function () {
			$(this).magnificPopup({
				delegate: 'a',
				type: 'image',
				gallery: {
					enabled: true
				}
			});
		});

		$('.licenses-menu a').click(function (e) {
			e.preventDefault();

			var $this = $(this);
			var tab = $this.data('tab');
			var wrap = '.' + tab + '-wrap';

			if ($(window).width() >= 768) {
				$('.licenses-menu a').removeClass('active');
				$this.addClass('active');

				$('.certificates-wrap').removeClass('active');
				$(wrap).addClass('active');
			} else {
				var $menu = $this.parent();
				if ($menu.hasClass('open')) {
					$('.licenses-menu a').removeClass('active');
					$this.addClass('active');

					$('.certificates-wrap').removeClass('active');
					$(wrap).addClass('active');

					$this.prependTo($menu);

					$menu.removeClass('open');
				} else {
					$menu.addClass('open');
				}
			}
		});

		$('.certificates-wrap .company').each(function () {
			$(this).magnificPopup({
				delegate: '.item a',
				type: 'image',
				gallery: {
					enabled: true
				}
			});
		});

		$('.vacancies .position').click(function () {
			var $this = $(this);

			$this.parent().toggleClass('show');
			$this.next('.desc').slideToggle();
		});

		$('.file-btn').click(function () {
			$(this).parent().find('input').trigger('click');
		});

		$('.file-wrap input').change(function (e) {
			var $this = $(this);
			var $wrap = $this.closest('.file-wrap');
			var val = $this.val().split('\\');
			var name = val[2];
			$wrap.find('.file-name').text(name);
			$wrap.find('.file-btn').addClass('hide');
			$wrap.find('.file-val').addClass('show');
		});

		$('.file-val .file-delete').click(function () {
			var $wrap = $(this).closest('.file-wrap');
			$wrap.find('.file-wrap input').val('');
			$wrap.find('.file-btn').removeClass('hide');
			$wrap.find('.file-val').removeClass('show');
		});

		document.addEventListener('wpcf7mailsent', function (event) {
			var form_id = '#form-popup';
			if ('559' == event.detail.contactFormId) {
				form_id = '#form-popup2';
			}

			$.magnificPopup.open({
				items: {
					src: form_id
				},
				type: 'inline'
			});
		}, false);

		var title = $('.event-item .title').text();
		$('input[name="your-event"]').val(title);

		$('.search-mobile').click(function (e) {
			e.preventDefault();

			$('.search-form').toggleClass('show');
			$(this).toggleClass('with-close');
			$('.search-field').focus();
		});

		$('.slideout-menu .secondmenu .menu-item-has-children > a').click(function (e) {
			e.preventDefault();

			var $this = $(this);

			$this.toggleClass('show-sub-menu');
			$this.next().toggleClass('show');
		});

		$('.wp-block-table').wrap('<div class="table-wrap"></div>');

		if ($(window).width() < 768) {
			$('.projects-cats .active').prependTo('.projects-cats');

			$('.projects-cats a').click(function (e) {
				var $this = $(this);

				if ($this.hasClass('active')) {
					e.preventDefault();

					$('.projects-cats').toggleClass('open');
				}
			});
		}
	});

	$(window).scroll(function () {
		update_animates();

		var $window = $(window);
		var scrollTop = $window.scrollTop();
		var $body = $('body');

		if (scrollTop > 120) {
			$body.addClass('scrolling');
		} else {
			$body.removeClass('scrolling');
		}
	});

	$(window).load(function () {
		$(window).trigger('scroll');
	});
})(jQuery);

